import { render, staticRenderFns } from "./CrearAlertasBaseModal.vue?vue&type=template&id=595cfb72&"
import script from "./CrearAlertasBaseModal.vue?vue&type=script&lang=ts&"
export * from "./CrearAlertasBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports